/** Rhino/Java-совместимый аналог `.length()` для platform-скриптов. */
export function javaLength(value: unknown): number {
  if (value == null) return 0
  if (typeof value === 'string') return value.length
  if (typeof (value as { length?: unknown }).length === 'function') {
    return (value as { length: () => number }).length()
  }
  if (typeof (value as { length?: unknown }).length === 'number') {
    return (value as { length: number }).length
  }
  if (typeof (value as { size?: unknown }).size === 'function') {
    return (value as { size: () => number }).size()
  }
  return 0
}
